import React, {useState} from 'react';
import _ from 'lodash';
import localeText from '@locale';
import Header from '~/components/MobileHeader/index';
import Banner from '~/components/MobileBanner/index';
import Content from './Content';
import NotFound from '~/components/404';
import Doc from '../DocList';
import {getLandingConfig} from '~/utils/tools';
import {LATEST_VERSION} from '~/utils/constant';
import BannerBg from '~/assets/images/landing/banner/banner_bg_landingpage_mobile.png';
import './index.less';

const LandingPageMobile = ({history, match}) => {
  const {
    params: {locale, version}
  } = match;
  const [menuOpen, setMenuOpen] = useState(false);
  const landingConfig = getLandingConfig(locale);

  const versionKeys = Object.keys(landingConfig).sort((p, n) => landingConfig[p].order - landingConfig[n].order);
  if (_.indexOf(versionKeys, version) === -1) {
    return <NotFound />;
  }

  return (
    <>
      {LATEST_VERSION.includes(version) ? (
        <div className='landing-page-mobile'>
          <Header
            locale={locale}
            version={version}
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            isTutorial={false}
            configData={landingConfig?.[version]?.header || []}
            versionKeys={versionKeys}
            history={history}
          />
          <Banner
            bannerBg={BannerBg}
            // BannerLeft={BannerLeft}
            // BannerRight={BannerRight}
            title={localeText('COMMON.TXT_TITLE')}
            description={localeText('COMMON.TXT_DESCRIPTION')}
          />
          <Content configData={landingConfig?.[version]?.content || {}} />
          <div className='copy-right'>{localeText('COMMON.TXT_COPY_RIGHT', new Date().getFullYear())}</div>
        </div>
      ) : <Doc match={{params: {locale, version}}} history={history} />}
    </>
  );
};

export default LandingPageMobile;
